import { Button, Col, Form, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { useEffect, useState } from 'react'
import EduLearnerService from '../../services/EduLearnerService';
import { openNotification } from '../../utils';

interface NoteCreateProps {
    learnerId: string;
    onNoteAdded: () => void;
    onClose: any;
    getNotes: () => void;
}

const NoteCreate: React.FC<NoteCreateProps> = ({ learnerId, onNoteAdded, onClose, getNotes }) => {
    const [noteForm] = Form.useForm();
    const [loading, setLoading] = useState(false)

    const createNote = (values: any) => {
        setLoading(true);
        let noteData = {
            "note": values.note
        }
        EduLearnerService.createNote(learnerId, noteData)
            .then(() => {
                openNotification('success', 'Success', 'Note added');
                noteForm.resetFields();
                onNoteAdded();
                getNotes();
                setLoading(false);
                onClose();
            })
            .catch(() => {
                openNotification('error', 'Error', 'Failed to add note');
                setLoading(false);
            });
    };

    useEffect(() => {
        noteForm.resetFields();
    }, [onClose, noteForm])

    return (
        <div>
            <Row style={{ marginTop: '3em' }}>
                <Col span={24}>
                    <h3>Add Note</h3>
                    <Row justify={'center'}>
                        <Col span={24}>
                            <Form form={noteForm} layout="vertical" onFinish={createNote}>
                                <Form.Item
                                    name="note"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Note required',
                                        },
                                        {
                                            pattern: new RegExp(/\S/),
                                            message: 'Note cannot be empty or spaces only',
                                        },
                                    ]}
                                >
                                    <TextArea
                                        showCount
                                        style={{ height: 120, marginBottom: 15 }}
                                        placeholder="Note"
                                    />
                                </Form.Item>
                                <Form.Item wrapperCol={{ offset: 21, span: 24 }}>
                                    <Button loading={loading} className='oneamz-primary-button' htmlType="submit">
                                        Save
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )
}

export default NoteCreate
